import styled from "styled-components";

export const ContainerWrapperForm = styled.section`
  color: ${({ theme }) => theme.colors.purple};

  @media (max-width: 768px) {
    width: 100%;
  }

  form {
    display: flex;
    flex-direction: column;
    width: 100%;

    div {
      background-color: white;
    }

    a {
      color: ${(props) => props.theme.colors.purple};
      font-size: 0.875rem;
      text-align: end;
      margin-bottom: 12px;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    button {
      margin-bottom: 18px;
    }
  }

  footer {
    a {
      display: flex;
      align-items: center;
      text-decoration: none;
      color: ${({ theme }) => theme.colors.purple};
      font-family: ${(props) => props.theme.font.mangueira.bold};

      svg {
        margin-right: 6px;
        margin-left: -6px;
        margin-top: -3px;
        color: ${({ theme }) => theme.colors.purple};
      }
    }
  }

  @media (max-height: 762px) {
    form {
      a {
        font-size: 10px;
        margin-bottom: 6px;
      }

      button {
        height: 34px;
        margin-bottom: 12px;

        span {
          font-size: 14px !important;
        }
      }
    }

    footer {
      a {
        font-size: 12px;
        svg {
          margin-right: 6px;
          margin-left: -6px;
          margin-top: -3px;
          width: 12px;
          height: 12px;
        }
      }
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  & > h2 {
    text-align: center;
    margin-bottom: 0;
    color: ${({ theme }) => theme?.colors?.black2};
    font-size: 26px;
    font-family: "Mangueira Medium";
  }

  @media (max-height: 762px) {
    & > h2 {
      font-size: 18px;
    }
  }
`;

export const ContainerForm = styled.div`
  width: 100%;
  transition: all 0.5s ease-out;
  max-height: 100%;

  @media (max-width: 768px) {
    max-height: 500px;
    overflow: hidden;
  }
`;
